import { LoginState } from './../../../models/LoginState';
import { MutationTree } from 'vuex';

export const LoginMutations = {
	UPDATE_LOGIN_DETAILS: 'UPDATE_LOGIN_DETAILS',
	CLEAR_LOGIN_DETAILS: 'CLEAR_LOGIN_DETAILS',
	UPDATE_COMMUNICATION_VALUE: 'UPDATE_COMMUNICATION_VALUE',
	CLEAR_TOKEN: 'CLEAR_TOKEN'
}

export const mutations: MutationTree<any> = {
	[LoginMutations.UPDATE_LOGIN_DETAILS] (state: LoginState, payload: string) {
		state.userJWT = payload
	},
	[LoginMutations.CLEAR_LOGIN_DETAILS] (state: LoginState) {
		state.userJWT = null;
	},
	[LoginMutations.UPDATE_COMMUNICATION_VALUE] (state: LoginState, payload: { value: string }) {
		state.communication = payload.value;
	},
	[LoginMutations.CLEAR_TOKEN] (state: LoginState) {
		state.userJWT = null;
	}
}
